// API base URL.
//   • If REACT_APP_API_BASE is set (production), use it verbatim.
//   • Otherwise use a RELATIVE base ('') so calls hit /api/* on the SAME origin
//     the page loaded from. In dev, setupProxy.js forwards /api → the backend.
//     This makes LAN-IP and HTTPS-tunnel (ngrok) testing work with one origin.
export const API_BASE = process.env.REACT_APP_API_BASE || '';
